import * as React from "react";
import Hyperlink from "../../Shared/Link/Hyperlink";
import Render from "../../Shared/Render";
import { StyleClass } from "../../Shared/Styles/CSS";
import { ToggleQuickJournal } from "./ToggleQuickJournal/ToggleQuickJournal";
import { QuickJournalArrowIcon } from "../BottomRight/BottomRightGlyphIcons";

export function QuickJournalToggleIcon({ showWhen }: { showWhen: boolean }) {
    const style = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: 0.94,
        overflow: "visible",
        lineHeight: 0,
        zIndex: 2,
        transition: "transform 140ms ease, filter 140ms ease, opacity 140ms ease",
        ":hover": {
            transform: "translateY(-1px) scale(1.04)",
            filter: "brightness(1.08) saturate(1.06) drop-shadow(0 0 7px rgba(255, 207, 100, 0.22))",
        },
        ":active": {
            transform: "translateY(1px) scale(0.98)",
            filter: "brightness(0.96) saturate(0.98) drop-shadow(0 0 3px rgba(255, 207, 100, 0.12))",
        },
    };

    return (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Render
                id="quickJournalToggleIcon"
                when={showWhen}
                withClasses={StyleClass(`quickJournalToggleIcon`, style)}
            >
                <Hyperlink whenClicked={() => ToggleQuickJournal()}>
                    <QuickJournalArrowIcon />
                </Hyperlink>
            </Render>
        </div>
    );
}
